module.exports = __webpack_public_path__ + "img/blog-wa-gb-status-not-showing.3c237265.webp";